<template>
    <div>
      <v-card class="main-container">
        <v-card-title style="color:gray; font-weight:bold; padding-left: 0px;">
  
          <!-- <v-chip v-if="view_type=='moderator'"
            color="#16336e"
            dark
            class="new-proposal"
            @click="new_council()">
            <v-icon small class="ma-1">mdi-plus-box</v-icon> 
            Новый совет
          </v-chip> -->
  
          <div style="width: 1000px; margin-left: 20px;">
  
            <v-tabs v-model="current_tab_id">
              <v-tab
                exact-active-class="custom-color"
                v-for="(item, i) in menus"
                :key="item.slug"
                :style="{color: $mainColor + ' !important', caretColor: $mainColor + ' !important'}">
                    {{item.name}}
              </v-tab>
            </v-tabs>
          </div>
        </v-card-title>

        <v-card-text>
            <v-row v-if="current_tab_id == 0">  <!-- export_emails -->
                <template>
                    <v-card class="ma-2" width="100%">
                        <v-row class="ml-4 mp-4">
                            <v-col>
                                <div class="input-container input-name modal-mul-select">
                                    <v-select
                                    v-model="selected_export_type"
                                    :items="type_list"
                                    item-text="descr"
                                    item-value="type"
                                    outlined
                                    chips
                                    required
                                    ></v-select>
                                </div>
                            </v-col>
                            <v-col class="pt-7">
                                <v-btn :color="$mainColor" label dark @click='get_emails()' :disabled="selected_export_type == 'none'" >
                                    Выгрузить
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-card class="ml-8 mp-4 mb-8" width="95%">
                                <p class="ma-0">В текст письма обязательно добавляйте эту ссылку, чтобы пользователи имели возможность отписаться:</p>
                                <b>&lt;a href="https://proposal.nrcki.ru/unsubscribe" target="_blank"&gt;Отписаться от&nbsp;рассылки&lt;/a&gt;</b>
                                <p>{{ emails_text }}</p>
                            </v-card>
                        </v-row>
                    </v-card>
                </template>        
            </v-row>

            <v-row v-if="current_tab_id == 1">  <!-- audience -->
                <template>
                    <user-audience-list/>
                </template>
            </v-row>

            <v-row v-if="current_tab_id == 2">  <!-- attendance -->
                <template>
                    <user-attendance-list/>
                </template>
            </v-row>

        </v-card-text>
    </v-card>
    </div>
</template>


<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';

  import UserAttendanceList from '../components/dashboard/UserAttendanceList.vue'
  import UserAudienceList from '../components/dashboard/UserAudienceList.vue'

  export default {
    name: 'Dashboard',
    components: {
        UserAttendanceList,
        UserAudienceList,
    },
    data() {
      return {
        current_tab_id: 0,
        current_menu: 'export_emails',
        menus: [
            {name:'Выгрузка email-ов',slug:'export_emails', icon:'mdi-email-multiple'},
            {name:'Слушатели',slug:'audience', icon:'mdi-chart-pie'},
            {name:'Посещаемость',slug:'attendance', icon:'mdi-chart-pie'},
        ],

        emails_text: '',
        type_list: [
            {type: 'none', descr: 'Выберите тип выгрузки'},
            // {type: 'all_active', descr: 'Все активные пользователи'},
            {type: 'rsini_active_users_24', descr: 'Участники ФСНЭ-24'},
            {type: 'rsini_active_users_25', descr: 'Участники ФСНЭ-25'},
        ],
        selected_export_type: 'none',
      }
    },

    watch:{
        selected_export_type(val) {
            this.emails_text = ''
        }
    },

    methods: {
        ...mapActions([
            'LOAD_EMAIL_LIST',
        ]),
        ...mapMutations([
            'UPDATE_OVERLAY',
        ]),

                
        get_emails(){
            this.UPDATE_OVERLAY(true)

            if(this.selected_export_type == 'none'){
                return
            }

            this.LOAD_EMAIL_LIST({type: this.selected_export_type})
                .then((data) => {
                    console.log(data)
                    if(data.error){
                        this.$messageHelper(data.error, 'error', 3000);
                    }
                    else{
                        this.emails_text = data.emails
                    }
                    this.UPDATE_OVERLAY(false)
                })
                .catch((e) => {
                    this.UPDATE_OVERLAY(false)
                });
        },

        choose_stat(slug){
            this.current_menu = slug
        },

    },

};
</script>
